<template>
<ul class='about'>
    <li v-for="(item,index) in list" :key="index">
        <h4>{{item.dec}}</h4>
        <p>{{item.title}}</p>
    </li>
</ul>
</template>
<script>
export default {
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        },
        // dec:{
        //     type:String,
        //     default:'孩子王，是一家数据驱动的、基于用户关系经营的创新型新家庭全渠道服务商，采用深度会员模式，全渠道为会员提供一站式母婴童商品解决方案、育儿成长服务及社交互动。创立10年，已累计服务3000万新家庭，是国内母婴童商品零售与增值服务的知名品牌。'
        // }
    }
}
</script>

<style lang="scss" scoped>
.about {
    position: absolute;
    bottom: 55px;
    left: 0;
    width: 1200px;
    height: 58px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    @include Flex;
    // flex-direction: column;
    align-items: center;
    justify-content: space-between;
    z-index:1;
    // >p {
    //     width: 1200px;
    //     text-align: center;
    //     line-height: 24px;
    //     color: #696B82;
    //     @include Transition;
    //     @media #{$media} {
    //         width: 1000px;
    //     }
    // }
    // > div {
    //     background: url('~@assets/images/home/bg_about@2x.png') no-repeat;
    //     background-size: 100% 100%;
    //     width: 100%;
    //     height: 224px;
    // }
    // ul {
    //     @include Flex;
    //     margin: 0 auto;
    //     width: 1200px;
    //     padding: 60px 0;
    //     padding-top: 68px;
    //     @include Transition;
    //     @media #{$media} {
    //         width: 1000px;   
    //     }
        li {
            flex: 1;
            color: #fff;
            text-align: center;
            border-right: 2px solid #fff;
            h4 {
                color: #fff;
                font-size: 17px;
                font-weight: normal;
            }
            p {
                font-size: 29px;
                line-height: 29px;
                font-weight: 700;
            }

            &:last-child{
                border-right: 0;
            }
        }
    // }
}
</style>

